import { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { tokens } from "../theme";
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

import { useAuth } from '../components/AuthProvider';

function Login() {
  // Contains values in the text fields
  const [fieldValues, setFieldValues] = useState({
    username: '',
    password: ''
  })

  const [error, setError] = useState('');

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { setToken } = useAuth();

  const navigate = useNavigate();

  /**
   * Creates a new account based on the fieldValues
   * and sends it to the server.
   * @param {{ username: string, displayName: string, password: string}} fieldValues
   * The values to create the account with.
   */
  async function handleLogin() {
      setError('');
      try {
          const res = await api.post('/login_account', fieldValues, { withCredentials: true });
          if (res.data.accessToken) {
              setToken(res.data.accessToken)
              console.log('Login successful');
              navigate('/'); // Redirect to home page after successful login
          }
      } catch (err) {
          if (err.response && err.response.status === 401) {
              setError(err.response.data.message);
          } else {
              setError('Något oväntat gick fel');
          }
      }
  }

  return (
    <div>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
        <Typography
          variant="h3"
          color={colors.ceriseAccent[100]}
          fontWeight="medium"
          sx={{m: "0 0 10px 0"}}
          >
          Välkommen!
        </Typography>
        <Typography
          variant="h4"
          color={colors.ceriseAccent[100]}
          fontWeight="medium"
          sx={{m: "0 0 10px 0"}}
          >
          Logga in
        </Typography>
        <TextField
          label="Username"
          variant="outlined"
          value={fieldValues.username}
          onChange={(e) => setFieldValues({...fieldValues, username: e.target.value})}
          sx={{m: "10px 0 0 0"}}
          >
        </TextField>
        <TextField
          label="Password"
          variant="outlined"
          type="password"
          value={fieldValues.password}
          onChange={(e) => {
            setFieldValues({...fieldValues, password: e.target.value})
          }}
          sx={{m: "10px 0 0 0"}}
          >
        </TextField>
        {
            error ?
            <Typography
            variant="h6"
            color={colors.redAccent[300]}
            fontWeight="medium" 
            sx={{m : "10px 0 0px 0px" }}
            >
            {error}
            </Typography>
            : null
        }
        <Button
          variant="outlined"
          color={colors.gray[900]}
          sx={{width: "150px", m: "10px 0 0 0px"}}
          onClick={handleLogin}
        >
            <LoginIcon/>
            <Typography
            variant="h6"
            color={colors.gray[100]}
            fontWeight="medium" 
            sx={{m : "5px 0 5px 15px" }}
            >
            Logga in
            </Typography>
        </Button>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" sx={{m: "10px 0 0 0"}}>
          <Typography
              variant="h6"
              color={colors.gray[100]}
              fontWeight="medium"
              sx={{m: "0 5px 0 0"}}
              >
              Har du inget konto? 
          </Typography>
          <Typography
              variant="h6"
              color={colors.ceriseAccent[100]}
              fontWeight="medium" 
              onClick={() => navigate('/create_account')}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
              Skapa ett här
          </Typography>
        </Box>
      </Box>
    </div>
  )
}

export default Login;